const enquiryNotificationTemplate = `
<div class="ui-notification">
  <h3>New Enquiry Received</h3>
  <div class="message">
    Please choose from one of the following options
    
    <a class="btn btn-success" ng-click="enquiryAcceptedByUser(enquiryId, senderId)">Accept</a>
    <a class="btn btn-warning" ng-click="enquiryHeldByUser(enquiryId, senderId)">Hold</a>
    <a class="btn btn-danger" ng-click="enquiryRejectedByUser(enquiryId, senderId)">Reject</a>
  </div>
</div>
`;

export default enquiryNotificationTemplate;



// WEBPACK FOOTER //
// ./client/app/common/templates/notification/enquiryNotificationTemplate.js